import { useContent } from '@/context/ContentContext';

export default function Footer() {
  const { t } = useContent();
  if (!t) return null;
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-paper border-t border-[var(--line)]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-10 py-14 sm:py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 sm:gap-10 items-end">
          <div className="md:col-span-8">
            <div className="font-serif text-5xl sm:text-6xl md:text-8xl leading-none tracking-[-0.03em]">
              {t.brand}
              <span className="text-ember">.</span>
            </div>
            <p className="mt-4 sm:mt-6 max-w-md font-serif italic text-ink-dim text-base md:text-lg">
              {t.footer.tagline}
            </p>
          </div>
          <div className="md:col-span-4 space-y-2 font-mono text-[10px] uppercase tracking-[0.22em] sm:tracking-[0.28em] text-ink-dim">
            <div className="flex justify-between gap-3 border-t border-[var(--line)] pt-3">
              <span>Studio</span>
              <span className="text-ink text-right">Cyprus · EU · UK</span>
            </div>
            <div className="flex justify-between gap-3 border-t border-[var(--line)] pt-3">
              <span>Contact</span>
              <span className="text-ember break-all text-right">{t.contact.email_contact_value}</span>
            </div>
            <div className="flex justify-between gap-3 border-t border-[var(--line)] pt-3">
              <span>Est.</span>
              <span className="text-ink">MMXXII</span>
            </div>
          </div>
        </div>
        <div className="mt-10 sm:mt-16 flex flex-wrap items-center justify-between gap-3 sm:gap-4 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.22em] sm:tracking-[0.28em] text-ink-dim border-t border-[var(--line)] pt-6 sm:pt-8">
          <span>© {year} ROTAMA Company Ltd — {t.footer.rights}</span>
          <span>Forged in Cyprus ⚒</span>
        </div>
      </div>
    </footer>
  );
}
